import { useSelector } from 'react-redux';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import useQueryParams from '../../../navigation-utils/useQueryParams';
import { selectDocumentationActiveObjectData } from '../../../reducers/documentation/salesforceDocumentationReducer';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import { SalesforceItem } from '../../parser/ParserTypes';
import { buildConfigurationItemId } from '../salesforce-documentation-card/helpers';
import {
  DocumentationCardContentViewType,
  DocumentationCardItem,
} from '../salesforce-documentation-card/types';

export function useObjectContentHandleDeepLink({
  elements,
  handleSetConfigurationItem,
}: {
  elements: SalesforceItem[];
  handleSetConfigurationItem: (props: DocumentationCardItem) => void;
}) {
  const queryParams = useQueryParams();
  const elementsLoaded = useSelector(selectDocumentationActiveObjectData);

  useRunOnceWhenTruthy(() => {
    const configurationItemId = queryParams.get(DeepLinkSearchParams.configurationItemId);
    if (configurationItemId) {
      const item = elements.find(
        (element) => buildConfigurationItemId(element) === configurationItemId,
      );
      if (item) {
        handleSetConfigurationItem({
          item,
          clearHistory: true,
          contentType: DocumentationCardContentViewType.default,
        });
      }
    }
  }, Boolean(elementsLoaded));
}
